import { render, staticRenderFns } from "./MapPolygon.vue?vue&type=template&id=5a88f853&scoped=true&"
import script from "./MapPolygon.vue?vue&type=script&lang=js&"
export * from "./MapPolygon.vue?vue&type=script&lang=js&"
import style0 from "./MapPolygon.vue?vue&type=style&index=0&id=5a88f853&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a88f853",
  null
  
)

export default component.exports